import { useQuery } from "@tanstack/react-query";
import { getBlogPost } from "../blog";
import type { BlogPost } from "../blog";

export function useBlogPost(id?: number) {
  return useQuery<BlogPost>({
    queryKey: ["blogPost", id],
    queryFn: () => getBlogPost(id as number),
    enabled: Number.isFinite(id),
  });
}
